import { render, staticRenderFns } from "./TaskListItem.vue?vue&type=template&id=23c5f5a8&"
import script from "./TaskListItem.vue?vue&type=script&lang=js&"
export * from "./TaskListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports